import { render } from "./SuscripcionesList.vue?vue&type=template&id=1b4a5888&scoped=true"
import script from "./SuscripcionesList.vue?vue&type=script&lang=js"
export * from "./SuscripcionesList.vue?vue&type=script&lang=js"

import "./SuscripcionesList.vue?vue&type=style&index=0&id=1b4a5888&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b4a5888"]])

export default __exports__